import React from 'react'
import Jahazi from '../../assets/shower.jpg'
import ViaLogo from '../../assets/ccu.jpg'
import Fafoco from '../../assets/tool.jpg'
import { motion } from 'framer-motion'

const Technicals = () => {
    // Parent container variants to control the children
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.3, // Delay between each card's animation
            }
        }
    };

    // Individual card variants
    const cardVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: { 
            opacity: 1, 
            y: 0,
            transition: { duration: 2, ease: "easeOut" } 
        }
    };

    return (
        <section className="featured">
            <div className="overlay">
                <div className="container h">
                    <div className="space"></div>
                    <div className="space"></div>
                    
                    {/* The motion.div here controls the staggering of the cards inside it */}
                    <motion.div 
                        className="cards"
                        variants={containerVariants}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: false, amount: 0.1 }}
                    >
                        {/* Card 1 */}
                        <motion.div className="card" variants={cardVariants}>
                            <div className="wrapper">
                                <h3 className="card-head-primary">Electrical Systems</h3>
                                <div className="card-image-container">
                                    <img src={ViaLogo} alt="Via Platform" className="card-image" />
                                    <div className="description">
                                        <p className="card-text-dark">
                                            Domestic and commercial wiring, conduit routing, cable termination, and troubleshooting.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </motion.div>

                        {/* Card 2 */}
                        <motion.div className="card" variants={cardVariants}>
                            <div className="wrapper">
                                <h3 className="card-head-primary">Precision Tooling</h3>
                                <div className="card-image-container">
                                    <img src={Fafoco} alt="Amazing Food Company" className="card-image" />
                                    <div className="description">
                                        <p className="card-text-dark">
                                            Expertly operating power tools and diagnostic instruments for masonry, conduit cutting, and electrical testing.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </motion.div>

                        {/* Card 5 */}
                        <motion.div className="card" variants={cardVariants}>
                            <div className="wrapper">
                                <h3 className="card-head-primary">Maintenance</h3>
                                <div className="card-image-container">
                                    <img src={Jahazi} alt="Plumbing Solutions" className="card-image" />
                                    <div className="description">
                                        <p className="card-text-dark">
                                            Appliance repair, power system installations, and utility piping (Plumbing).
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </motion.div>
                    </motion.div>
                </div>
                <div className="space"></div>
                <div className="space"></div>
                <div className="space"></div>
            </div>
        </section>
    )
}

export default Technicals